import { BulkSpreadsheet, parseBool, parseNum, type BulkColumn } from '../shared/BulkSpreadsheet';
import { employeeService } from '@kss/api';
import type { EmployeeCreate } from '@kss/api';
import { loadStoreOptions, loadCompanyOptions } from '../shared/formLoaders';

const columns: BulkColumn<EmployeeCreate>[] = [
  { key: 'code', header: 'Code', sample: 'EMP-001' },
  { key: 'firstName', header: 'First name', required: true, sample: 'Jane' },
  { key: 'lastName', header: 'Last name', sample: 'Doe' },
  { key: 'email', header: 'Email', sample: 'jane@company.com' },
  { key: 'phone', header: 'Phone' },
  { key: 'designation', header: 'Designation', sample: 'Senior Engineer' },
  { key: 'department', header: 'Department', sample: 'Engineering' },
  { key: 'joiningDate', header: 'Joining date', dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'salary', header: 'Salary', dataType: 'number', parse: parseNum as never, sample: '50000' },
  { key: 'storeId', header: 'Store', dataType: 'lookup', loadOptions: loadStoreOptions },
  { key: 'companyId', header: 'Company', dataType: 'lookup', loadOptions: loadCompanyOptions },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkEmployee() {
  return (
    <BulkSpreadsheet<EmployeeCreate> title="Bulk import employees" entityLabel="employee" backPath="/panel/employees" columns={columns} module="Employee"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await employeeService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
